var mediaQueryBreakpointsInPx = {
  mobile: '480px'
};
export default mediaQueryBreakpointsInPx;